import React, { createContext, useEffect, useState } from 'react';
import { Layout, message } from 'antd';
import './index.scss';
import { Helmet } from 'react-helmet';
import { ErrorBoundary } from '@sentry/react';
import Header from './components/header';
import Footer from './components/footer';
import * as styles from './secondaryLayout.module.scss';
import classNames from 'classnames';
import { useLocation } from '@reach/router';
import scrollTo from 'gatsby-plugin-smoothscroll';
import useIsMobile from '@/hooks/useIsMobile';
import FloatingNews from '@/components/floating-news';

const Content = Layout.Content;
interface LayoutProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  ref?: React.LegacyRef<HTMLTitleElement>;
  showFooter?: boolean;
  type?: string;
  headerclassname?: string;
}
const SecondaryLayout = ({
  title = 'MTT Network',
  description,
  children,
  ref,
  showFooter = true,
  type = '',

  headerclassname,
}: LayoutProps) => {
  const location = useLocation();
  /** 📢收到通知 */

  message.config({
    top: useIsMobile() ? 80 : 100,
    duration: 2,
  });
  useEffect(() => {
    // 每次路由变化时滚动到页面顶部
    setTimeout(() => {
      scrollTo('#top', 'start');
    }, 0);
  }, []);

  return (
      <ErrorBoundary fallback={<p>发生错误，请稍后再试。</p>}>
        <div id="top"></div>
        <Layout className="layout secondaryLayout" ref={ref}>
          {/* SEO优化 */}
          <Helmet>
            <title>{title || 'MTT Network'}</title>
            <meta name="description" content={description || 'description'} />
            <meta name="keywords" content="key words" />
            {/* 其他通用的元数据 */}
          </Helmet>
          <Header
            className={classNames(styles.header, headerclassname)}
            type={type}
          />
          <FloatingNews />
          <Content className="content">{children}</Content>
          {showFooter && <Footer />}
        </Layout>
      </ErrorBoundary>
  );
};

export default SecondaryLayout;
